<template>
  <div class="event-details">
    <section class="page-wrapper">
      <div class="page-center">
            
        <m-row>
          <m-col lg="7">
            
            <m-row>
              <m-col lg="12">
                <h1>BBQ Party 2025</h1>
              </m-col>
            </m-row>
            
            <m-row>
              <m-col lg="12">
                
                <div class="logo-wrap">
                  <img src="/assets/images/example1.png" alt="Logo" class="logo" />
                </div>
              </m-col>
            </m-row>
            
            <m-row>
              <m-col lg="12">
                <p>Lorem ipsum</p>
              </m-col>
            </m-row>
            
            <!-- Tickets -->
            <NewPublicEventSelectTicketsList 
              :tickets="item.tickets"
            />


          </m-col>
          <m-col lg="5">
            <m-row class="border-bottom">
              <m-col lg="12">
                <div class="left-subject">Datum:</div>
                <div class="right-content">
                  <span>{{ item.date }}</span>
                </div>
              </m-col>
            </m-row>

            <m-row class="border-bottom">
              <m-col lg="12">
                <div class="left-subject">Pris från:</div>
                <div class="right-content">
                  <span>{{ lowest_price }}</span>
                </div>
              </m-col>
            </m-row>

            <m-row class="border-bottom" style="border-bottom: none !important;">
              <m-col lg="12">
                <div class="left-subject">Plats:</div>
                <div class="right-content">
                  <span>{{ location }}</span>
                </div>

              </m-col>
            </m-row>

            <m-row>
              <m-col lg="12" v-if="item.google_maps && item.google_maps.lat">
                <google-map
                  :center="{ lat: item.google_maps.lat, lng: item.google_maps.lng }"
                  :zoom="16"
                  style="height: 256px"
                  id="map"
                  ref="Map"
                  class="shadow-sm p-2 mb-5 rounded"
                >
                  <google-map-marker
                    :position="{ lat: item.google_maps.lat, lng: item.google_maps.lng }"
                  ></google-map-marker>
                </google-map>
              </m-col>
            </m-row>

            <m-row>
              <m-col lg="12">
                <memlist-button style="display: block; width: 100%;" variant="primary">Boka nu</memlist-button>
              </m-col>
            </m-row>

            <m-row class="border-bottom">
              <m-col lg="12">
                <div class="left-subject">Kontakt:</div>
                <div class="right-content">
                  <span>{{ item.contact_name }}</span>
                  <p>{{ item.contact_email }}</p>
                </div>
                
              </m-col>
            </m-row>

            <m-row class="border-bottom">
              <m-col lg="12">
                <div class="left-subject">Max antal biljetter:</div>
                <div class="right-content">
                  <span>{{ item.max_tickets }}</span>
                </div>
                
              </m-col>
            </m-row>

            <m-row class="border-bottom">
              <m-col lg="12">
                <div class="left-subject">Totalt antal platser:</div>
                <div class="right-content">
                  <span>{{ item.num_seats }}</span>
                </div>
                
              </m-col>
            </m-row>

            <m-row class="border-bottom">
              <m-col lg="12">
                <div class="left-subject">Återkommande:</div>
                <div class="right-content">
                  <span>Nej</span>
                </div>
                
              </m-col>
            </m-row>

            <m-row class="border-bottom">
              <m-col lg="12">
                <p>Avbokningspolicy</p>
                <span>Bokningen är bindande</span>
                
              </m-col>
            </m-row>

            <m-row>
              <m-col lg="12">
                <div class="social-icons">
                  <span class="svg-icon-event-blue">
                    <inline-svg src="/assets/svg/x.svg"></inline-svg>
                  </span>
                  <span class="svg-icon-event-blue">
                    <inline-svg src="/assets/svg/facebook.svg"></inline-svg>
                  </span>
                  <span class="svg-icon-event-blue">
                    <inline-svg src="/assets/svg/instagram2.svg"></inline-svg>
                  </span>
                  <span class="svg-icon-event-blue">
                    <inline-svg src="/assets/svg/youtube.svg"></inline-svg>
                  </span>
                </div>
              </m-col>
            </m-row>


          </m-col>
        </m-row>
      </div>
    </section>
  </div>
</template>


<script>
import messageParent from '@/core/services/messageParent';
import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import i18nService from "@/core/services/i18n.service.js";
import NewPublicEventSelectTicketsList from './NewPublicEventSelectTicketsList.vue';

export default {
  name: 'NewPublicEventFullDetails',
  components: {
    NewPublicEventSelectTicketsList,
  },
  props: [],
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentMember']),
    location() {
      return '...';
    },
    lowest_price() {
      return '...';
    },
  },
  async mounted() {
    this.event_id = this.$route.params.event_id;
  },
  data() {
    return {
      event_id: null,
      item: {
        tickets: []
      }
    };
  },
  watch: {
  
  },
  methods: {

  }
};
</script>
<style scoped>

.event-details{width:100%;padding:24px 0}
.page-wrapper{display:flex;justify-content:center;padding:2rem 0}
.page-center{width:100%;max-width:1024px;padding:0 2rem;box-sizing:border-box}
@media (max-width:992px){
  .event-details :deep(.m-row){flex-direction:column!important}
}

.logo-wrap{width:100%;border-radius:12px;overflow:hidden;margin:12px 0 24px}
.logo-wrap img{width:100%;height:auto;display:block;object-fit:cover}

h1{margin:0 0 12px;font-size:2rem;font-weight:600;line-height:1.2}
p{margin:0 0 1em;font-size:1rem;color:#495057}

memlist-card{padding:1rem;border:1px solid #e9ecef;border-radius:8px;background:#f8f9fa}

.border-bottom{border-bottom:1px solid #e9ecef!important;padding:12px 0}

.border-bottom [class*="m-col-"]{
  display:flex;
  flex-wrap:nowrap;
  align-items:flex-start;
  justify-content:space-between;
  gap:12px
}

.left-subject{flex:0 0 auto;font-weight:600;color:#212529;margin:0}
.right-content{flex:1 1 auto;text-align:right;font-size:.95rem;color:#495057;min-width:0}
.right-content span,
.right-content p{display:block;margin:0}

:deep(memlist-button[variant="primary"]) {
  display:block;        /* make it behave like a row element   */
  width:100%;           /* span the whole parent column        */
  margin:20px 0;
}
#map{border-radius:8px;overflow:hidden}

.social-icons{display:flex;gap:8px;margin-top:12px}
.svg-icon-event-blue{display:inline-block;width:24px;height:24px;line-height:0;cursor:pointer;transition:transform .15s}
.svg-icon-event-blue:hover{transform:translateY(-2px)}
.svg-icon-event-blue :deep(svg){width:100%;height:100%;display:block}
.svg-icon-event-blue,
.svg-icon-event-blue :deep(*){color:#35aaca;fill:currentColor}



</style>